module.exports = __webpack_public_path__ + "img/american.f175bb50.png";